import moment from 'moment';

const LOCAL_DATE_TIME_FORMAT = 'ddd, MMM D, YYYY, h:mm:ss a [GMT]Z';

export const formatLocalDateTime = (date: Date) =>
  moment(date, LOCAL_DATE_TIME_FORMAT)
    .utcOffset('en-CA')
    .format(LOCAL_DATE_TIME_FORMAT);

export const formatLocalDateFromString = (value?: string | null) => {
  if (!value || value.trim() === '') {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return formatLocalDateTime(date);
};
